import cookie from "./cookie";
import tools from "./tools";
export default {
    cookie,
    tools
};